module.exports = __webpack_public_path__ + "img/002-psd.a6b38203.svg";